'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = require('@material-ui/core/styles');

var useStyles = styles.makeStyles(function () {
    return styles.createStyles({
        inline: {
            margin: '0 1rem',
            display: 'inline-block',
        },
    });
});

exports.useStyles = useStyles;
